import { makeAutoObservable, runInAction } from 'mobx';
import { NetworkRequestHandler } from 'http/NetworkRequestHandler';
import {
  API_V1_ADMIN_ACCOUNTS_ROLES,
  API_PROFILE_V1_DIABET_TYPES,
  API_V1_ADMIN_MEASUREMENT_TYPES,
} from 'consts';
import { AxiosMethod, LoadingStatus } from 'enums';
import { AccountRole, OptionType, EventType } from 'types';

class CommonStore {
  roles: AccountRole[] = [];

  eventTypes: EventType[] = [];

  tagOptions: OptionType[] = [];

  groupOptions: OptionType[] = [];

  diabetTypeName: OptionType[] = [];

  apps: OptionType[] = [];

  appsVersions: OptionType[] = [];

  status: LoadingStatus = LoadingStatus.IDLE;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchAccountRoles() {
    this.roles = [];
    this.status = LoadingStatus.PENDING;
    const roles = await NetworkRequestHandler.sendRequest({
      url: API_V1_ADMIN_ACCOUNTS_ROLES,
      method: AxiosMethod.GET,
    });
    runInAction(() => {
      this.roles = roles;
      this.status = LoadingStatus.DONE;
    });
  }

  async fetchEventTypes() {
    this.eventTypes = [];
    this.status = LoadingStatus.PENDING;
    const items = await NetworkRequestHandler.sendRequest({
      url: API_V1_ADMIN_MEASUREMENT_TYPES,
      method: AxiosMethod.GET,
    });
    runInAction(() => {
      this.eventTypes = items;
    });
  }

  async fetchDiabetTypeName() {
    this.diabetTypeName = [];
    this.status = LoadingStatus.PENDING;
    const diabetsType = await NetworkRequestHandler.sendRequest({
      url: API_PROFILE_V1_DIABET_TYPES,
      method: AxiosMethod.GET,
    });
    this.diabetTypeName = diabetsType.map((diabetType: string) => ({
      label: diabetType,
      value: diabetType,
    }));
  }
}

export default new CommonStore();
